module.exports = __webpack_public_path__ + "img/29400.0fac431d.jpg";